/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckoutResponse
 */
export interface CheckoutResponse {
    /**
     * 
     * @type {string}
     * @memberof CheckoutResponse
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckoutResponse
     */
    checkoutUrl?: string;
}

export function CheckoutResponseFromJSON(json: any): CheckoutResponse {
    return CheckoutResponseFromJSONTyped(json, false);
}

export function CheckoutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactionId': !exists(json, 'transactionId') ? undefined : json['transactionId'],
        'checkoutUrl': !exists(json, 'checkoutUrl') ? undefined : json['checkoutUrl'],
    };
}

export function CheckoutResponseToJSON(value?: CheckoutResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactionId': value.transactionId,
        'checkoutUrl': value.checkoutUrl,
    };
}

